import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DeviceFrameset } from "react-device-frameset";
import "react-device-frameset/styles/marvel-devices.min.css";
import templateService from "../../../services/template.service";
import {toast} from 'react-toastify'
function AddSmsTemplate() {
  
  const [isEcx, setIsEcx] = useState(false);
  const [template, setTemplate] = useState(null);

  const [txtContent,setTxtContent] = useState(null);
  const [txtType,setTxtType] = useState(null)
  const [txtUsedBy,settxtUsedBy] = useState("CLINIC")

  const [templateTypes,setTemplateTypes] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    //check if templateid contains ecx or cli in first 3 characters
    getTemplateTypes()
  }, []);

 
  const handleTextAreaChange = (event)=>{
        setTxtContent(event.target.value)
  }
  const getTemplateTypes = ()=>{
    templateService.getTemplateTypes()
    .then(res=>{
        setTemplateTypes(res.data)
    })
    .catch(err=>{
        console.log(err)
    })
}
  const handleAdd = ()=>{
     //things needed
        //type , mediumType="SMS", subjectLine=null, content, usedBy,voiceSequence=null 
    const data = {
        "type": txtType,
        "mediumType":"SMS",
      //  "subjectLine" : null,
        "content" : txtContent,
        "usedBy" : txtUsedBy,
       // "voiceSequence" : null
    }
    templateService.saveEcxTemplate(1,data)
    .then(res=>{
         toast.success("Successfully Added New Template.",{
            position:toast.POSITION.BOTTOM_RIGHT
         })
         navigate('/sms-template');
    })
    .catch(err=>{
      toast.error("Cannot Create New Template.",{
        position:toast.POSITION.BOTTOM_RIGHT
     })
     console.log(err)
    })
  }

  const handleCancel = ()=>{
    navigate('/sms-template');
  }

  const handletxtTypeChange = (event)=>{
    setTxtType(event.target.value)
  }
  const handletxtUsedByChange = (event) =>{
    settxtUsedBy(event.target.value)
  }

  return (
    <>
      <div className="container container-xxl">
        <div className="row">
          <div className="col-6">
            <div className="d-flex justify-content-center">
              <DeviceFrameset device="iPhone X">
                <div
                  style={{
                    marginTop: "100px",
                    marginLeft: "30px",
                    padding: "15px",
                    display: "inline-block",
                    position: "relative",
                    width: "300px",
                    height: "auto",
                    backgroundColor: "lightyellow",
                    borderRadius: "30px",
                  }}
                >
               {txtContent}
                </div>
              </DeviceFrameset>
            </div>
          </div>
          <div className="col-6">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Sms Template</h4>
               
                <div className="form-group">
                                <label className="form-label" htmlFor="">Type</label>
                                <select name="smsType" id="smsType" onChange={handletxtTypeChange} className="form-select form-select-sm">
                                        {templateTypes && templateTypes.map((item,index)=>{
                                            return   <option key={index} value={item}>{item}</option>
                                        })}
                                       
                                    </select>
                </div>
                <div className="form-group mt-2">
                                <label className="form-label" htmlFor="">Used By</label>
                                <select name="usedBy" id="usedBy" onChange={handletxtUsedByChange} className="form-select form-select-sm">
                                     <option value="CLINIC">Clinic</option>
                                     <option value="ECX">EyeconX</option>
                                       
                                    </select>
                </div>
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    Content
                  </label>
                  <textarea
                    name=""
                    id=""
                    rows="5"
                    className="form-control"
                    value={txtContent}
                    maxLength={600}
                    onChange={handleTextAreaChange}
                  ></textarea>
                   <div className="form-text">Characters : {txtContent && txtContent.length} / 600</div>
                </div>
                <div className="d-flex justify-content-between mt-3">
                                      <button className="btn btn-primary btn-sm" onClick={handleAdd}>Add New Template</button>
                                      <button className="btn btn-secondary btn-sm" onClick={handleCancel}>Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddSmsTemplate;
